const HandleFilterQuestionnaireEnum = Object.freeze({
    HAS_SETTING_IN_THE_PROGRAM: { value: 'has_program', text: 'プログラムに設定あり' },
    NO_SETTING_IN_THE_PROGRAM: { value: 'no_program', text: 'プログラムに設定なし' },
    HAS_RESPONSE_PERIOD: { value: 'has_period', text: '回答期間あり' },
    NO_RESPONSE_PERIOD: { value: 'no_period', text: '回答期間なし' },
});

export default HandleFilterQuestionnaireEnum;
